import { render, staticRenderFns } from "./bulk-update-view.vue?vue&type=template&id=01e45fc8&scoped=true"
import script from "./bulk-update-view.vue?vue&type=script&lang=js"
export * from "./bulk-update-view.vue?vue&type=script&lang=js"
import style0 from "./bulk-update-view.vue?vue&type=style&index=0&id=01e45fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e45fc8",
  null
  
)

export default component.exports